export default class ExtraForm {
  constructor(data = {}) {
    this.name = data.name || null
    this.description = data.description || null
    this.numberOfRooms = data.numberOfRooms || 1
    this.persons = data.persons || 1
    this.extraBeds = data.extraBeds || 0
    this.minimumRate = data.minimumRate || 1
    this.rackRate = data.rackRate || 1
    this.extraBedRate = data.extraBedRate || 0
    this.childBedRate = data.childBedRate || 0
    this.allotmentAlert = data.allotmentAlert || 0
    this.totalChildren = data.totalChildren || 0
    this.size = data.size || 10
    this.sizeIncludeTerrace = data.sizeIncludeTerrace || false
    this.view = data.view || null
    this.bathroom = data.bathroom || null
    this.facilities = data.facilities || []
    this.bedType = data.bedType || null
    this.wifiIncluded = data.wifiIncluded || false
    this.smokingPreference = data.smokingPreference || null
  }

  static validator() {
    return {
      name: 'required|min:3|max:255',
      description: 'required|min:3',
      numberOfRooms: 'required|numeric|min_value:1',
      persons: 'required|numeric|min_value:1',
      extraBeds: 'required|numeric',
      minimumRate: 'required|min_value:1',
      rackRate: 'required|numeric|min_value:1',
      extraBedRate: 'required|numeric',
      childBedRate: 'required|numeric',
      allotmentAlert: 'required|numeric',
      totalChildren: 'required|numeric',
      size: 'required|numeric|min_value:10',
      sizeIncludeTerrace: 'required',
      view: 'required|min:3',
      bathroom: 'required|min:3',
      facilities: 'required',
      bedType: 'required',
      wifiIncluded: 'required',
      smokingPreference: 'required',
    }
  }
}
